/**
 * defined商品品类相关处理
 */

// defined商品品类 字段映射关系
const tableArr = new Map([
  ['PS_C_CATEGORY', ['PARENT_ID_DEFIEND', 'PARENT_ID']], // 商品品类
  ['PS_C_PRO', ['MODIFIERNAME', 'PS_C_CATEGORY_ID']], // 商品SPU
  ['PS_C_SKU', ['MODIFIERNAME', 'PS_C_CATEGORY_ID']], // 商品SKU
  ['ST_C_PRO_SOURCE_STRATEGY', ['MODIFIERNAME', 'PS_C_CATEGORY_ID']], // TOB商品寻源
  ['SG_C_TOC_STRATEGY', ['PS_C_CATEGORY_ID', 'PS_C_PRODIM_ID']], // TOC仓库辐射设置
  ['ST_C_PRO_LOGISTIC_STRATEGY', ['PS_C_CATEGORY_ID', 'PS_C_PRODIM_ID']], // 商品物流设置
  ['ST_C_SHOP_LOGISTIC_STRATEGY', ['PS_C_CATEGORY_ID', 'PS_C_PRODIM_ID']], // 店铺物流设置
  ['ST_C_SPLIT_BEFORE_SOURCE_STRATEGY', ['PS_C_CATEGORY_ID', 'PS_C_PRODIM_ITEM_ID']], // 寻源前拆单策略
]);

// 列表 defined商品品类 字段映射关系
const getTableQueryTables = new Map([
  ['PS_C_PRO', { colname: 'MODIFIERNAME', colid: 130812 }], // 商品SPU
  ['PS_C_SKU', { colname: 'MODIFIERNAME', colid: 130812 }], // 商品SKU
  ['ST_C_PRO_SOURCE_STRATEGY', { colname: 'MODIFIERNAME', colid: 130812 }], // TOB商品寻源
  ['SG_C_TOC_STRATEGY', { colname: 'PS_C_CATEGORY_ID', colid: 1700839332 }], // TOC仓库辐射设置
  ['ST_C_PRO_LOGISTIC_STRATEGY', { colname: 'PS_C_CATEGORY_ID', colid: 1700848365 }], // 商品物流设置
])

/**
 * 单对象
 * 商品品类、商品SPU、TOB商品寻源、TOC仓库辐射设置、商品物流设置、店铺物流设置、寻源前拆单策略
 */
const singleObjectTables = [
  'PS_C_CATEGORY', 'PS_C_PRO', 'ST_C_PRO_SOURCE_STRATEGY',
  'SG_C_TOC_STRATEGY', 'ST_C_PRO_LOGISTIC_STRATEGY',
  'ST_C_SHOP_LOGISTIC_STRATEGY', 'ST_C_SPLIT_BEFORE_SOURCE_STRATEGY'
]

// 单对象-复制（公用于defined商品类目、defined属性表单）
const copyTables = [
  'PS_C_CATEGORY', 'PS_C_PRO', 'ST_C_PRO_SOURCE_STRATEGY',
  'SG_C_TOC_STRATEGY', 'ST_C_PRO_LOGISTIC_STRATEGY',
  'CP_C_WAREHOUSE', 'CP_C_RSTORE', 'CP_C_CUSTOMER',
  'CP_C_SUPPLIER', 'PS_C_SKU'
]

const request = (config) => {
  return config
  const { tableName } = vm.$route.params;

  if ([...getTableQueryTables.keys()].includes(tableName) && ['/p/cs/QueryList', '/p/cs/export'].includes(config.url) && /^\/SYSTEM\/TABLE\//.test(vm.$route.fullPath)) {
    // 【查询】【导出】入参替换
    const [oldColname, newColname] = tableArr.get(tableName);
    const searchData = JSON.parse(config.data.get('searchdata'))
    searchData.fixedcolumns[newColname] = searchData.fixedcolumns[oldColname]
    delete searchData.fixedcolumns[oldColname]
    config.data.set('searchdata',JSON.stringify(searchData))
  }

  const urlArr = [
    [
      '/api/cs/md/category/save', // 商品类目
      '/api/cs/md/pro/save', // 商品SPU
      // '/api/cs/md/proGoods/save',
      '/api/cs/md/v2/stCProSourceStrategy/save', // TOB商品寻源
      '/api/cs/sg/add', // TOC仓库辐射设置
      '/api/cs/md/proLogisticStrategy/save', // 商品物流设置
      '/api/cs/md/shopLogisticStrategy/save', // 店铺物流设置
      '/api/cs/oc/oms/v1/splitBeforeSourceStrategy/save', // 寻源前拆单策略
    ], // 页面定制接口
    '/p/cs/objectAdd', '/p/cs/objectSave', '/p/cs/batchSave'
  ] // 保存接口（定制 & 标准）
  if (singleObjectTables.includes(tableName) && urlArr.flat().includes(config.url)) {
    const handlerStandardTable = (isJson) => {
      // 标准接口入参解析
      let params = isJson ? {} : new URLSearchParams();
      const all = new URLSearchParams(config.data)
      all.forEach((val, key) => {
        let newVal = val
        if (key == 'data') {
          // 复制页面商品品类入参特殊处理
          newVal = JSON.parse(newVal);
          if (newVal[tableName].hasOwnProperty(oldColname)) {
            newVal[tableName][newColname] = $('.CATEGORY_NAME input[hidden="hidden"]').val();
          }
          !isJson && (newVal = JSON.stringify(newVal))
        }
        isJson ? (params[key] = newVal) : params.append(key, newVal);
      })
      return params
      /* let configData = decodeURIComponent(config.data.toString());
      configData.split('&').forEach((i) => {
        const [key, val] = i.split('=');
        let newVal = val.replace(new RegExp(oldColname, 'g'), newColname);
        if (config.url == '/p/cs/objectAdd' && key == 'data') {
          // 复制页面商品品类入参特殊处理
          let v = JSON.parse(newVal);
          v[tableName][newColname] = $('.CATEGORY_NAME input[hidden="hidden"]').val();
          newVal = JSON.stringify(v);
        }
        params.append(key, newVal);
      }); */
    }
    const handlerCustTable = () => {
      let params = config.data;
      const { before, after, data } = config.data
      let handlerTableName = tableName
      const subTable = new Map([
        ['ST_C_SPLIT_BEFORE_SOURCE_STRATEGY', 'ST_C_SPLIT_BEFORE_SOURCE_STRATEGY_CATEGORY_ITEM'],
        ['ST_C_SHOP_LOGISTIC_STRATEGY', 'ST_C_SHOP_LOGISTIC_STRATEGY_ITEM'],
      ]) // 获取该单对象需处理子表的表名
      if (subTable.get(tableName)) {
        handlerTableName = subTable.get(tableName)
      }
      if (data.hasOwnProperty(handlerTableName)) {
        data[tableName][newColname] = data[tableName][oldColname]
        delete data[tableName][oldColname]
        params = { ...config.data, data }
        if (before) {
          before[tableName][newColname] = before[tableName][oldColname]
          delete before[tableName][oldColname]
          params.before = before
        }
        if (after) {
          after[tableName][newColname] = after[tableName][oldColname]
          delete after[tableName][oldColname]
          params.after = after
        }
        if (Array.isArray(data[handlerTableName])) {
          data[handlerTableName][0][newColname] = data[handlerTableName][0][oldColname]
        }
      }
      return params
    }
    // 【保存】【批量修改】入参替换
    const [oldColname, newColname] = tableArr.get(tableName);
    let params = config.data;
    if (urlArr[0].includes(config.url)) {
      // 定制接口入参解析
      params = handlerCustTable()
    } else {
      params = handlerStandardTable(true)
      params.id = params.objid
      params.data[tableName].ID = params.objid
    }
    config.data = params;
  }
}

const response = (config) => {
  return config
  const { tableName } = vm.$route.params;

  if (config.config.url == '/p/cs/getObject' && vm.$route.fullPath.indexOf('/SYSTEM/TABLE_DETAIL/V/SG_C_TOC_STRATEGY/249231378/New') > -1) {
    // TOC仓库辐射设置-新增页面去掉标准的“商品品类”字段
    const arr = config.data.data.addcolums[0].childs.filter((i) => i.colname != 'PS_C_PRODIM_ID');
    config.data.data.addcolums[0].childs = arr;
  }

  // if (config.config.url == '/p/cs/getObject' && vm.$route.fullPath.indexOf('/SYSTEM/TABLE_DETAIL/V/ST_C_PRO_SOURCE_STRATEGY/249231779') > -1) {
  //   // TOB商品寻源-去掉标准的“商品品类”字段
  //   const arr = config.data.data.addcolums[0].childs.filter((i) => i.colname != 'PS_C_CATEGORY_ID');
  //   config.data.data.addcolums[0].childs = arr;
  // }

  if (config.config.url == '/p/cs/getObjectForUpTmp' && tableName == 'PS_C_PRO') {
    // 商品SPU-批量修改 defined商品品类
    const field = config.data.data.addcolums[0].childs.find((i) => i.colname == 'MODIFIERNAME');
    field && (field.webconf = { batchModal: true }); // 以此标识判断单选
  }
}

const handleStandardListFormDefined = (datas) => {
  return
  // 列表-商品品类 defined处理
  if ([...getTableQueryTables.keys()].includes(datas.table)) {
    const { colname, colid } = getTableQueryTables.get(datas.table)
    let x = datas.dataarry.findIndex(it => it.colname == colname)
    if (x != -1) {
      datas.dataarry[x] = {
        "coldesc": t("商品类目"),
        "colname": colname,
        "isuppercase": false,
        "webconf": null,
        "colid": colid,
        "display": "defined",
        "type": "STRING"
      }
    }
  }
}

const handler = (tables, key, to, from) => {
  if (tables.includes(from.params.tableName)) {
    console.log(to, from)

    // 【新增/复制新增】保存接口完成后，再调属性保存
    if (from.params.itemId == 'New' && to.params.itemId != 'New') {
      const key = Object.values(from.params).join('-')
      const formNode = document.querySelector(`#extended-attrs-${key}`) // defined属性表单
      const copyId = sessionStorage.getItem(`${from.params.tableName}_definedForm_copy_itemId`)
      if (formNode && (copyId || to.params.itemId)) {
        formNode.__vue__.Save && formNode.__vue__.Save(null, to.params.itemId)
      }
    }

    const storage = (formCopy) => {
      if (from.params.itemId && formCopy && from.params.itemId != 'New' && to.params.itemId == 'New') {
        // 复制-保存原明细id
        sessionStorage.setItem(key, from.params.itemId)
      } else {
        sessionStorage.setItem(key, '')
      }
    }
    storage(false)
    // 判断是否点击复制按钮
    $('#actionCANCOPY').on('click', () => {
      storage(true)
    });
  }
}

const handleCopy = (to, from) => {
  return
  // 复制 保存原明细id,用来新增页面定制表单传参回显
  handler(copyTables, `${from.params.tableName}_definedForm_copy_itemId`, to, from)
}

const handleExtendAttr = (to, from) => {
  return
  // 复制 保存“属性值录入方式”的值，用来控制新增页面子表显示隐藏
  const tableArr = ['PS_C_SALES_INFO', 'PS_C_PRODIM'] // 商品销售属性、商品基本属性
  handler(tableArr, `${from.params.tableName}_copy_type`, to, from)
}

export default {
  request,
  response,
  handleCopy,
  handleExtendAttr,
  handleStandardListFormDefined,
  tableArr: {
    QueryListTables: [...getTableQueryTables.keys()],
    singleObjectTables,
    copyTables
  }
}
